export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./layout.vue?vue&type=template&id=4ad206a4&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/layout.vue?vue&type=template&id=4ad206a4&
// module id = 330
// module chunks = 2